import React from 'react'
import { Spinner } from 'react-bootstrap'

const FallBack = () => {
  return (
    <div
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 'inherit',
            flexDirection: 'column'
        }}
    >
        <Spinner style={{color: '#0B70D1'}} animation="border" />
        <p style={{ marginTop: '0.5rem '}}>Loading...</p>
    </div>
  )
}

export default FallBack